import { render } from "./holidays-index.vue?vue&type=template&id=427a0d95&scoped=true"
import script from "./holidays-index.vue?vue&type=script&lang=js"
export * from "./holidays-index.vue?vue&type=script&lang=js"

import "./holidays-index.vue?vue&type=style&index=0&id=427a0d95&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-427a0d95"]])

export default __exports__